var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3wx2tqsla",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1980"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3157",
    d: "M18 0A18 18 0 1 1 0 18 18 18 0 0 1 18 0z",
    style: {
      fill: "url(#g3wx2tqsla)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 294",
    transform: "translate(8 17)",
    style: {
      stroke: "#fff",
      strokeWidth: 2,
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.99,
    height: 2.221,
    rx: 1.111,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 17.99,
    height: 0.221,
    rx: 0.111,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3321",
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.88 1.221H1.11a.11.11 0 0 1 0-.221h17.77a.11.11 0 0 1 0 .221z",
    style: {
      stroke: "none"
    },
    transform: "rotate(-90 22.495 5.495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11 0h17.77a1.11 1.11 0 1 1 0 2.221H1.11A1.11 1.11 0 1 1 1.11 0z",
    style: {
      fill: "#fff",
      stroke: "none"
    },
    transform: "rotate(-90 22.495 5.495)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-add.4b01f8870bd6fe6745bd7ea880ecee6a.svg";